import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import FormControl from 'react-bootstrap/FormControl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';

import CustomPagination from '../../CustomPagination/CustomPagination';
import Link from '../../Link/Link';
import Loader from '../../../components/Common/Loader';

import messages from '../../../locale/messages';
import debounce from '../../../helpers/debounce';
import removeCancelReason from '../../../actions/siteadmin/CancelReason/removeCancelReason';
import { addCancelReason } from '../../../actions/siteadmin/CancelReason/addCancelReason';
import { capitalizeFirstLetter } from '../../../helpers/capitalizeFirst';
import getCurrentPage from '../../../helpers/getCurrentPage';
import { demoRestriction } from '../../../actions/demoRestriction';
import { CommonAdminEditIcon, CommonAdminTrashIcon } from '../../Common/Assets/SVGIcon/CommonSvgIcon';

import bt from '../../../components/commonStyle.css';
import s from './CancellationReasonList.css';
export class CancellationReason extends Component {
	static propTypes = {
		cancelReasons: PropTypes.object,
	}
	constructor(props) {
		super(props)
		this.state = {
			currentPage: 1,
			searchList: ""
		}
	}

	handleKeywordSearch = debounce((searchList) => {
		const { cancelReasons: { refetch } } = this.props
		let variables = {
			currentPage: 1,
			searchList: searchList
		}
		this.setState({ searchList, currentPage: 1 });
		refetch(variables);;
	});

	handleDelete = async (id, currentPage) => {
		const { cancelReasons: { refetch, getAllCancelReason }, removeCancelReason, demoRestriction } = this.props;
		currentPage = await getCurrentPage({ results: getAllCancelReason?.results, page: currentPage });
		let variables = { currentPage };
		const isRestrict = await demoRestriction({ restrictType: 'cancelReason', restrictValue: Number(id) });
		if (isRestrict) return;
		const response = await removeCancelReason(id, currentPage);
		if (response?.status == 200) {
			await refetch(variables);
			this.setState({ currentPage });
		}
	}

	handleChange = async (e, id, reason, userType) => {
		const { addCancelReason, cancelReasons: { refetch }, demoRestriction } = this.props;
		let data = {};
		data = {
			id: id,
			reason: reason,
			userType: userType,
			isActive: e.target.value
		}
		const isRestrict = await demoRestriction({ restrictType: 'cancelReason', restrictValue: Number(id) });
		if (isRestrict) return;
		this.setState({ currentPage: 1 });
		let variables = { currentPage: 1 };
		await addCancelReason(data);
		await refetch(variables);
	}

	paginationData = (currentPage) => {
		const { cancelReasons: { refetch } } = this.props;
		let variables = { currentPage };
		this.setState({ currentPage });
		refetch(variables);
	}

	render() {
		const { cancelReasons, cancelReasons: { getAllCancelReason, loading } } = this.props;
		const { currentPage } = this.state;
		const { formatMessage } = this.props.intl;
		return (
			<div className={'whiteDropdown'}>
				<div className={s.exportDisplay}>
					<div className={s.searchGroupContainer}>
						<div className={cx(s.searchInput, 'searchInputRTL')}>
							<FormControl type='text' placeholder={formatMessage(messages.searchOnly)} onChange={(event) => this.handleKeywordSearch(event.target && event.target.value)} className={bt.formControlInput} />
						</div>
					</div>
					<div className={cx(s.exportTextSection)}>
						<Link to={"/siteadmin/cancel-reasons/add"} className={cx(bt.btnPrimary, bt.displayInlineBlock)} ><FormattedMessage {...messages.addCancelReason} /></Link>
					</div>
				</div>
				<div className="clearfix"></div>

				{
					loading && <div>
						<Loader type="circle" />
					</div>
				}
				{!loading &&
					<div className='tableOuterContainer'>
						<Table className="tableContainer">
							<thead>
								<tr>
									<th scope="col"><FormattedMessage {...messages.id} /></th>
									<th scope="col"><FormattedMessage {...messages.cancelReason} /></th>
									<th scope="col"><FormattedMessage {...messages.cancelledBy} /></th>
									<th scope="col"><FormattedMessage {...messages.status} /></th>
									<th scope="col"><FormattedMessage {...messages.action} /></th>
									<th scope="col"><FormattedMessage {...messages.deleteAction} /></th>
								</tr>
							</thead>
							<tbody>
								{
									cancelReasons?.getAllCancelReason?.results && cancelReasons?.getAllCancelReason?.results?.length > 0 && cancelReasons?.getAllCancelReason?.results?.map((item, index) => {
										let isActive = item.isActive == "true" ? "1" : "0";
										return (
											<tr key={index}>
												<td data-label={formatMessage(messages.id)}>{item?.id}</td>
												<td data-label={formatMessage(messages.cancelReason)}>{capitalizeFirstLetter(item?.reason)}</td>
												<td data-label={formatMessage(messages.cancelledBy)}>{formatMessage(item?.userType == '1' ? messages['user'] : messages['partner'])}</td>
												<td data-label={formatMessage(messages.status)}>
													<div>
														<select name="isActive" onChange={(e) => this.handleChange(e, item?.id, item?.reason, item?.userType)} className={bt.selectInput} value={isActive}>
															<option value={"1"}>{formatMessage(messages.active)}</option>
															<option value={"0"}>{formatMessage(messages.inactive)}</option>
														</select>
													</div>
												</td>

												<td data-label={formatMessage(messages.action)}>
													<div>
														<Link to={'/siteadmin/cancel-reasons/edit/' + item.id} className={s.noLink}>
															<CommonAdminEditIcon className={cx(s.editIcon, 'editIconRTL')} />
															<span className={s.vtrMiddle}>
																<FormattedMessage {...messages.editAction} />
															</span>
														</Link>
													</div>
												</td>
												<td data-label={formatMessage(messages.deleteAction)} >
													<div>
														<Button onClick={() => this.handleDelete(item.id, currentPage)} className={s.iconBtn}>
															<CommonAdminTrashIcon className={cx(s.editIcon, 'editIconRTL')} />
															<span className={s.vtrMiddle}>
																<FormattedMessage {...messages.deleteAction} />
															</span>
														</Button>
													</div>
												</td>
											</tr>
										)
									})
								}
								{
									(!loading && (cancelReasons?.getAllCancelReason?.results && cancelReasons?.getAllCancelReason?.results?.length == 0)) && (
										<tr>
											<td colspan="12" className={'tableNoRecordCel'}><FormattedMessage {...messages.noResult} /></td>
										</tr>
									)
								}
							</tbody>
						</Table>
					</div>
				}
				{
					cancelReasons?.getAllCancelReason?.results && cancelReasons?.getAllCancelReason?.results?.length > 0
					&& <div className={cx(bt.space5, bt.spaceTop5)}>
						<CustomPagination
							total={cancelReasons.getAllCancelReason.count}
							currentPage={currentPage}
							defaultCurrent={1}
							defaultPageSize={10}
							change={this.paginationData}
							paginationLabel={formatMessage(messages.cancelReason)}
						/>
					</div>
				}
			</div>
		)
	}
}

const mapState = (state) => ({});

const mapDispatch = {
	removeCancelReason,
	addCancelReason,
	demoRestriction
};

export default injectIntl(compose(
	withStyles(bt, s),
	connect(mapState, mapDispatch)
)(CancellationReason));